goog.provide("shadow.js.shim.module$date_fns$locale$tr$default");
shadow.js.shim.module$date_fns$locale$tr$default = esm_import$date_fns$locale$tr.default;
